




























































import { Component, Vue, Prop } from 'vue-property-decorator'
import FormattedDate from '../../formatted-date/formatted-date.vue'
import { deleteNotification, setNotificationsStatus } from '@/store/notifications/reducer'
import { pushAnalyticsEvent } from '@/services/utils'
import { EventDetail } from '@/config/interface'

@Component({
  name: 'notifications-list-item',
  components: {
    FormattedDate,
  },
})
export default class NotificationsListItemComponent extends Vue {
  @Prop() headline!: string
  @Prop() content!: string
  @Prop() createdAt!: string
  @Prop() read!: boolean
  @Prop() notificationKey!: string
  @Prop() link!: string
  @Prop() lastChild!: boolean
  dismissTimeout = 0

  get actions() {
    return [
      {
        key: 'mark-as-read',
        condition: !this.link && !this.read,
        trigger: () => this.setStatus(),
        label: 'notifications__list__item__mark__as__read',
      },
      {
        key: 'mark-as-unread',
        condition: this.read,
        trigger: () => this.setStatus(false),
        label: 'notifications__list__item__mark__as__unread',
      },
      {
        key: 'dismiss',
        condition: true,
        trigger: () => this.dismiss(),
        label: 'notifications__list__item__dismiss',
      },
    ]
  }

  get availableActions() {
    return this.actions.filter((action) => action.condition)
  }

  setStatus(read = true): void {
    setNotificationsStatus({ notificationKeys: [this.notificationKey] }, read)
  }

  get dismissed() {
    return !!this.dismissTimeout
  }

  dismiss(): void {
    this.dismissTimeout = setTimeout(() => {
      deleteNotification(this.notificationKey)
    }, 3000)
  }

  undoDismiss(): void {
    clearTimeout(this.dismissTimeout)
    this.dismissTimeout = 0

    this.sendAnalytics({
      category: 'action',
      label: 'undo_dismiss',
    })
  }

  getTarget(link: string): string {
    const isRelativePath = !/(http(s?)):\/\//i.test(link)
    if (isRelativePath) {
      return '_top'
    }

    const url = new URL(link)
    if (window.location.hostname === url.hostname) {
      return '_top'
    } else {
      return '_blank'
    }
  }

  handleClick(): void {
    if (!this.link) return
    this.setStatus()

    this.sendAnalytics({
      category: 'link',
      label: 'notification',
    })
  }

  sendAnalytics({ category, label }: { category: string; label: string }): void {
    const event: EventDetail = {
      category,
      action: 'header.notifications_&_messages',
      label,
      URL: this.link,
    }
    pushAnalyticsEvent(event)
  }
}
